import React, {useState} from 'react';

import {Button, IconButton, Text} from '@albert-io/atomic';
import JoinCodeForm from 'client/Classrooms/StudentDashboard/JoinCodeForm/JoinCodeForm.react';

export default function StudentHomepageHeader() {
  const [showJoinClassModal, setShowJoinClassModal] = useState(false);

  return (
    <div className='col-span-full flex items-center px-x3 pt-x3'>
      <IconButton className='mr-x1' icon='bars' label='Toggle sidebar button' />
      <Text className='mr-x2 flex-1 font-black' size='xl'>
        Home
      </Text>
      <Button onClick={() => setShowJoinClassModal(true)} roundness='pill'>
        Join Class
      </Button>
      {showJoinClassModal && (
        <JoinCodeForm.Modal
          handleClose={() => setShowJoinClassModal(false)}
          onEnrollSuccess={() => setShowJoinClassModal(false)}
        />
      )}
    </div>
  );
}
